export default "./images/survio-27Z-p-assets-date_answer.png";